import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Cart } from 'src/app/shared/models/cart.interface';
import { CartService } from 'src/app/shared/services/cart.service';

@Component({
	selector: 'app-booking-summary',
	templateUrl: './booking-summary.component.html'
})
export class BookingSummaryComponent implements OnInit, OnChanges  {

	@Input('cartInput') cartInput: Cart = null; 

	public cart: Cart = null; 

	constructor(private activedRoute: ActivatedRoute,
		private _cartService: CartService) { }

	ngOnInit(): void {
		this.setCart();
	}

	ngOnChanges(): void{
		this.setCart();
	}

	private setCart() {
		if (this.cartInput == null && this.activedRoute.snapshot.queryParams.cart) {
			this.cart = this._cartService.processCart(JSON.parse(this.activedRoute.snapshot.queryParams.cart));
		} else {			
			this.cart = this.cartInput;
		}
		//console.log('BookingSummaryComponent.cart', this.cart);
	}
}
